import React from "react";
import setFieldValues9142B from "../../setFieldValues9142B";
const ModalUIActionButtons = ({
  formId,
  selectedRegistrationNumber,
  formSpecificScreens,
  screen,
  setScreen,
  resetAndClose,
  rnLinkingDataField,
  machine_name,
  formApi,
}) => {
  const finishAndClose = () => {
    // Get the current jobMsa value from the form
    const formValues = formApi.getState().values;
    const formMsaValue = formValues.jobMsa;
    
    setFieldValues9142B({
      formApi,
      machine_name,
      selectedRegistrationNumber,
      rnLinkingDataField,
      formMsaValue: formMsaValue, // Pass the form's MSA value
    });
    resetAndClose();
  };

  const goToNextScreen = () => {
    const currentScreenIndex = formSpecificScreens.indexOf(screen);
    const indexOfNextScreen =
      currentScreenIndex + 1 >= formSpecificScreens.length
        ? formSpecificScreens.length - 1
        : currentScreenIndex + 1;
    const nextScreen = formSpecificScreens[indexOfNextScreen];
    setScreen(nextScreen);
  };

  const goToPreviousScreen = () => {
    const currentScreenIndex = formSpecificScreens.indexOf(screen);
    const indexOfNextScreen =
      currentScreenIndex - 1 < 0 ? 0 : currentScreenIndex - 1;
    const prevScreen = formSpecificScreens[indexOfNextScreen];
    setScreen(prevScreen);
  };

  const currScreenIndex = formSpecificScreens.indexOf(screen);
  const showNextButton = currScreenIndex !== formSpecificScreens.length - 1;
  const showBackButton = currScreenIndex !== 0;
  const showFinishButton = currScreenIndex === formSpecificScreens.length - 1;

  return (
    <div>
      {!!showBackButton && (
        <button
          type="button"
          style={{ marginTop: "15px", float: "left" }}
          className={"usa-button usa-button--outline"}
          onClick={goToPreviousScreen}
        >
          Back
        </button>
      )}
      {!!showNextButton && (
        <button
          className={"usa-button usa-button-primary modal-submit"}
          disabled={!selectedRegistrationNumber}
          type="button"
          onClick={goToNextScreen}
        >
          Continue
        </button>
      )}
      {!!showFinishButton && (
        <button
          className={"usa-button usa-button-primary modal-submit"}
          disabled={!selectedRegistrationNumber}
          type="button"
          onClick={finishAndClose}
        >
          Finish
        </button>
      )}
    </div>
  );
};

export default ModalUIActionButtons;
